import { mapDTO } from '@twistezo/ts-dto-mapper'

import { Variables, WorkspaceProductSlice } from '../types'
import { VariablesDTO, WorkspaceProductSliceDTO } from './types'

export const toDTO = (from: Variables): VariablesDTO =>
  mapDTO<Variables, VariablesDTO>({ from }).transform(toDTO => {
    const { from, to } = toDTO

    return {
      ...toDTO,
      from: from && from.toISOString(),
      to: to && to.toISOString(),
    }
  })

export const fromDTO = (from: WorkspaceProductSliceDTO): WorkspaceProductSlice =>
  mapDTO<WorkspaceProductSliceDTO, WorkspaceProductSlice>({ from }).transform(
    (fromDTO: WorkspaceProductSliceDTO): WorkspaceProductSlice => fromDTO,
  )
